import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { isDesktop, validateZipCode } from '../../../../utils';
import { zipCodeSelector } from '../store/inventory-near-you/selector';
import LabelTransitionInput from '../../global/components/form-elements/LabelTransitionInput';
import { setZipCode } from '../store/inventory-near-you/reducer';
import { generateInventoryUrl, MAPPING } from '../helpers';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, FORM_SUBMIT_ACTION_CATEGORY } from '../../../../constants';
import { MODULE_NAME } from '../helpers/constant';

const { linkViewText } = MAPPING;

const ZipCodeInput = (props) => {
  const { zipCodePlaceholder, invalidZipCodeText, submitButtonIconClass, classWidth } = props;
  const dispatch = useDispatch();
  const zipCode = useSelector(zipCodeSelector);

  const [zipCodeVisible, setZipCodeVisible] = useState(zipCode);
  const [isValidZipCode, setIsValidZipCode] = useState(true);

  const zipCodeFormRef = useRef(null);
  const zipInputId = useRef(`zip-code-${Math.random().toString(36).substring(2)}`);

  const handleChangeZipCode = (e) => {
    const { value } = e.target;
    if (value.length <= 5) {
      setIsValidZipCode(validateZipCode(value));
      setZipCodeVisible(value);
    }
  };

  const handleSubmitZipCodeForm = (e) => {
    e.preventDefault();
    // redirect to the inventory page with the zip code
    if (isValidZipCode) {
      window.location.href = generateInventoryUrl(zipCode);
    }
  };

  const handleKeyDownInput = (event) => {
    const { key } = event;
    if (['e', '-', '+'].includes(key)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    setZipCodeVisible(zipCode);
  }, [zipCode]);

  useEffect(() => {
    if (zipCodeVisible !== zipCode && validateZipCode(zipCodeVisible)) {
      dispatch(setZipCode(zipCodeVisible));
    }
  }, [zipCodeVisible, zipCode, isValidZipCode, dispatch]);

  return (
    <div className={`zip-code-wrapper flex items-center w-full gap-20 md:gap-8 lg:w-1/2 xl:grow xl:mr-5 xl:max-w-306 2xl:mr-0 ${classWidth}`}>
      <form ref={zipCodeFormRef} className="relative w-full" onSubmit={handleSubmitZipCodeForm}>
        <LabelTransitionInput
          id={zipInputId.current}
          label={zipCodePlaceholder}
          type="number"
          inputMode="numeric"
          required
          isValid={isValidZipCode}
          errorMessage={invalidZipCodeText}
          name={zipInputId.current}
          inputClass="pl-8 pr-20"
          formGroupClass={isDesktop() ? 'message-above' : ''}
          value={zipCodeVisible}
          onChange={(e) => { handleChangeZipCode(e); }}
          onKeyDown={handleKeyDownInput}
        />
        <button type="submit" className={`absolute z-2 top-0 right-0 h-24 w-27 flex items-center justify-center text-black text-xl hover:text-primary-100 ${isValidZipCode ? '' : 'hidden'}`}
          data-event-trigger={CLICK_EVENT_TRIGGER}
          data-event-type={CLICK_EVENT_ACTION_TYPE}
          data-event-module={MODULE_NAME}
          data-event-label={zipCodeVisible}
          data-event-category={FORM_SUBMIT_ACTION_CATEGORY}
        >
          <span className={clsx('icomoon', submitButtonIconClass)} aria-hidden="true" />
          <span className="sr-only">{linkViewText}</span>
        </button>
      </form>
    </div>
  );
};

export default ZipCodeInput;